import { createContext } from "react";
const CategoryMasterContext = createContext();
export default CategoryMasterContext;

